import { c as _c } from "react/compiler-runtime";
import { DefaultValues } from "react-hook-form";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
const BudgetCheckDynamicForm = t0 => {
  const $ = _c(10);
  const {
    onNext,
    onPrevious,
    currentStepNumber,
    value,
    step
  } = t0;
  const t1 = value as DefaultValues<T>;
  let t2;
  if ($[0] !== onNext) {
    t2 = values => onNext(values);
    $[0] = onNext;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== currentStepNumber || $[3] !== onPrevious) {
    t3 = currentStepNumber > 0 ? () => onPrevious() : undefined;
    $[2] = currentStepNumber;
    $[3] = onPrevious;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== step.config || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <DynamicForm id="form" defaultValues={t1} onSubmit={t2} formDefinition={step.config} onPrevious={t3} />;
    $[5] = step.config;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default BudgetCheckDynamicForm;